import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTypeFontSize } from '../../../../../app/slice'
import { selectUserProfile } from '../../../../common/category/store/slice'
import { PopupExistedSubscription } from '../../../../common/popup/popupExistedSubscription'
import { selectUserType } from '../../../../layout/store/slice'
import { USER_TYPE } from '../../../../utils/authorization'
import classes from '../../../index.module.scss'
import { selectIsAvailableToAddNewSubscription } from '../../store/slice'
import {
  getIsAvailableToAddNewSubscription,
  getPricingPackages,
} from '../../store/thunk'
import { PopupBuyNow } from '../popupBuyNow'
import { PopupBuyPackage } from '../popupBuyPackage'
import { PopupUpgradeAccount } from '../popupUpgradeAccount'
import { Benefit } from './cardComponent/Benefit'
import { Package } from './cardComponent/Package'
import { SubscriptionFee } from './cardComponent/SubscriptionFee'
import { Title } from './cardComponent/Title'
import UpgradeBtn from './cardComponent/UpgradeBtn'
import { COLOR_SCHEME } from './constants'

export const PlanCard = ({
  isActive,
  isStandard,
  isPremium,
  isCustom,
  planData,
  itemKey,
  setIsShow,
  isBasic,
}) => {
  const dispatch = useDispatch()
  const userProfile = useSelector(selectUserProfile)
  const userType = useSelector(selectUserType)
  const additionNewSubscriptionData = useSelector(
    selectIsAvailableToAddNewSubscription,
  )
  const fontSizeType = useSelector(selectTypeFontSize)

  const [openPopupBuyPackage, setOpenPopupBuyPackage] = useState(false)
  const [openPopupUpgradeAcc, setOpenPopupUpgradeAcc] = useState(false)
  const [openPopupExistedSubscription, setOpenPopupExistedSubscription] =
    useState(false)
  const [isDefaultSelectPremium, setIsDefaultSelectPremium] = useState(false)

  const [isOpenBuyNow, setIsOpenBuyNow] = useState(false)
  const [isBuyPackage, setIsBuyPackage] = useState(false)

  const handleUpgrade = () => {
    !additionNewSubscriptionData?.isAvailable
      ? setOpenPopupExistedSubscription(true)
      : setOpenPopupUpgradeAcc(true)
  }

  const handleBuyPackage = () => {
    setOpenPopupBuyPackage(true)
  }

  const isPremiumOrStandard = isPremium || isStandard

  const canUpgradeToStandard =
    userType?.userTypeId > USER_TYPE.STANDARD && isStandard
  const canUpgradeToPremium =
    userType?.userTypeId > USER_TYPE.PREMIUM && isPremium

  const colorScheme = isActive ? COLOR_SCHEME.active : COLOR_SCHEME.deactive
  const standardOrPremiumColorScheme = isStandard
    ? COLOR_SCHEME.standard
    : COLOR_SCHEME.premium

  useEffect(() => {
    dispatch(getIsAvailableToAddNewSubscription())
    dispatch(getPricingPackages())
  }, [])

  return (
    <div className="wrapper">
      <div
        className={classes.userTypeCard}
        style={{
          backgroundColor: colorScheme.background,
          border: `1px solid ${colorScheme.border}`,
        }}
        key={itemKey}
      >
        <Title isActive={isActive} colorScheme={colorScheme} data={planData} />
        <SubscriptionFee
          isPremiumOrStandard={isPremiumOrStandard}
          standardOrPremiumColorScheme={standardOrPremiumColorScheme}
          data={planData?.subscriptionFee || ''}
          isCustom={isCustom}
        />
        <Benefit
          data={planData?.benefits || []}
          isCustom={isCustom}
          fontSizeType={fontSizeType}
        />
        <Package
          isActive={isActive}
          handleBuyPackage={handleBuyPackage}
          planId={planData?.id || null}
          isCustom={isCustom}
          isBasic={isBasic}
          fontSizeType={fontSizeType}
        />
        <UpgradeBtn
          handleUpgrade={handleUpgrade}
          canUpgradeToStandard={canUpgradeToStandard}
          canUpgradeToPremium={canUpgradeToPremium}
          setIsDefaultSelectPremium={setIsDefaultSelectPremium}
          setOpenPopupExistedSubscription={setOpenPopupExistedSubscription}
        />
      </div>
      {openPopupBuyPackage && (
        <PopupBuyPackage
          isShow={openPopupBuyPackage}
          setIsShow={setOpenPopupBuyPackage}
          setIsOpenBuyNow={setIsOpenBuyNow}
          userProfile={userProfile}
        />
      )}
      {isOpenBuyNow && (
        <PopupBuyNow
          isShow={isOpenBuyNow}
          setIsShow={setIsOpenBuyNow}
          userProfile={userProfile}
          isBuyPackage={isBuyPackage}
          onClosePlan={() => {
            setIsShow(false)
          }}
        />
      )}
      {openPopupExistedSubscription && (
        <PopupExistedSubscription
          isShow={openPopupExistedSubscription}
          setIsShow={setOpenPopupExistedSubscription}
          additionNewSubscriptionData={additionNewSubscriptionData}
          onClosePopupParent={setIsShow}
        />
      )}
      {openPopupUpgradeAcc && (
        <PopupUpgradeAccount
          isShow={openPopupUpgradeAcc}
          setIsShow={setOpenPopupUpgradeAcc}
          isDefaultSelectPremium={isDefaultSelectPremium}
          setIsOpenBuyNow={setIsOpenBuyNow}
          userProfile={userProfile}
          isBuyPackage={isBuyPackage}
          setIsBuyPackage={setIsBuyPackage}
        />
      )}
    </div>
  )
}

PlanCard.propTypes = {
  isActive: PropTypes.bool,
  isStandard: PropTypes.bool,
  isPremium: PropTypes.bool,
  isCustom: PropTypes.bool,
  isBasic: PropTypes.bool,
  planData: PropTypes.object,
  setIsShow: PropTypes.func,
  itemKey: PropTypes.number,
}
